import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react'

// Store
import { UserStoreContext } from '../../stores/UserStore'

/**
 * PublicRoute
 *
 * If a user is authenticated and attempts to access the component, they will be
 * redirected to their portfolio
 */
const PublicRoute = observer(({ component: Component }) => {
  // Context
  const { isAuthenticated, isEEUser } = useContext(UserStoreContext)
  const location = useLocation()

  // State
  const [from, setFrom] = useState('')

  useEffect(() => {
    // We only want to navigate the user if we have gathered all of the necessary data.
    // We will need to confirm they have an `accessToken` and have the information to determine
    // if they are an EE user or not.
    // Everyone lands on the same dashboard now (EXEC-1550), so this no longer has to
    // wait on an organization to build a path with — only on knowing if they are EE.
    // That also closes a hole where a non-EE user with no active organization set
    // matched none of the old branches and was left rendering the login page.
    if (isAuthenticated && isEEUser !== null) {
      setFrom(location.state ? location.state.from : { pathname: '/dashboard' })
    }
  }, [isAuthenticated, isEEUser])

  return isAuthenticated && from ? (
    <Navigate
      to={{
        pathname: from.pathname,
        replace: true,
      }}
    />
  ) : (
    <Component />
  )
})

export default PublicRoute
